import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { Heading, Text } from '../common/Typography';

const LandingFinalCta = () => (
  <section className="px-4 py-12 sm:px-6 lg:px-10 lg:py-16">
    <div className="mx-auto max-w-app-shell overflow-hidden rounded-2xl bg-[#0e1624] px-6 py-12 text-center text-white shadow-brand-lg sm:px-10">
      <Heading level={2} className="text-3xl text-white sm:text-4xl">
        Ready for a better club night?
      </Heading>
      <Text className="mx-auto mt-3 max-w-xl text-white/75">
        Players: join a club and get into sessions. Organisers: run the next night
        with matchmaking, sign-ups, and results in one place.
      </Text>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Button as={Link} to="/signup" variant="primary" size="large" className="w-full sm:w-auto">
          Create Account
        </Button>
        <Button
          as={Link}
          to="/login"
          variant="nav"
          size="large"
          className="w-full border border-white/25 sm:w-auto"
        >
          Log in
        </Button>
      </div>
    </div>
  </section>
);

export default LandingFinalCta;
